
import styles from "./errorFailed.module.css";
import { RiErrorWarningLine } from "react-icons/ri";


interface ErrorFailedProps {
    error: string;
}

export default function ErrorFailed({ error }: ErrorFailedProps) {
    return (
        <div className={styles.error}>
            <RiErrorWarningLine className={styles.errorIcon} />
            <p>{error}</p>
        </div>
    );
}
